import { call, put, select, takeEvery } from "typed-redux-saga/macro";
import { acquireEndpoint } from "../../utils/SmartMerchandiserAPI";
import { callApi } from "../../utils/SagaUtils";
import { getData } from "../../services/ApiService";
import {
  FETCH_ADAPTER_CONFIG,
  FETCH_ANALYTICS_CONFIG,
  GET_ADAPTER_CONFIG_DETAILS,
  GET_ANALYTICS_CONFIG_DETAILS,
} from "./AdapterConfigTypes";
import { LOAD_PLATFORM_INDEPENDENT_URL } from "../businessRules-list/BusinessRulesListTypes";
import { LOAD_ANALYTICS_SERVICE_URL } from "store/product/ProductTypes";
import { selectCurrentStoreId } from "store/store-list/StoreListSelectors";

function* getAdapterConfig() {
  try {
    const actionType = FETCH_ADAPTER_CONFIG;
    const constName = Object.keys({
      FETCH_ADAPTER_CONFIG,
    })[0].toString();
    const serviceType = LOAD_PLATFORM_INDEPENDENT_URL;

    const endpoint = acquireEndpoint(constName, serviceType);
    yield* call(callApi, actionType, getData, null, endpoint);
  } catch (error: any) {
    console.log("error", error);
  }
}

function* getAnalyticsConfig() {
  try {
    const actionType = FETCH_ANALYTICS_CONFIG;
    const storeId = yield* select(selectCurrentStoreId);
    const constName = Object.keys({
      FETCH_ANALYTICS_CONFIG,
    })[0].toString();
    const serviceType = LOAD_ANALYTICS_SERVICE_URL;

    const headersObj = {
      "x-store-id": storeId,
    };
    const optionsObj = {
      showGenericError: false,
    };

    const endpoint = acquireEndpoint(constName, serviceType);
    yield* call(
      callApi,
      actionType,
      getData,
      null,
      endpoint,
      headersObj,
      optionsObj,
    );
  } catch (e: any) {
    console.error(e);
    yield* put({ type: FETCH_ANALYTICS_CONFIG.FAILURE, message: e.message });
  }
}
export function* watchGetAdapterConfig() {
  yield* takeEvery(GET_ADAPTER_CONFIG_DETAILS, getAdapterConfig);
}

export function* watchGetAnalyticsConfig() {
  yield* takeEvery(GET_ANALYTICS_CONFIG_DETAILS, getAnalyticsConfig);
}
